import React from "react";
import { useObserver } from "mobx-react";

function SwitchButton({ label, onChange, value }) {
  return useObserver(() => (
    <label
      for="toogleA"
      class="flex items-center cursor-pointer w-full justify-between"
      dir="rtl"
    >
      <div class="ml-3 text-gray-700 font-medium">{label}</div>

      <div class="relative">
        <input
          id="toogleA"
          type="checkbox"
          class="hidden"
          checked={value}
          onChange={(e) => onChange(e.target.checked)}
        />
        <div
          class={`toggle__line w-10 h-4 ${
            value ? "bg-btnColor" : "bg-gray-200"
          }  rounded-full shadow-inner`}
        ></div>
        <div
          class={`toggle__dot absolute w-6 h-6 ${
            value ? "bg-primary" : "bg-white"
          } rounded-full shadow inset-y-0 left-0`}
        ></div>
      </div>
    </label>
  ));
}

export default SwitchButton;
